import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {
	generateTicketReplyDraftMutation,
	GenerateTicketReplyDraftInput,
} from './__generated__/generateTicketReplyDraftMutation.graphql';

// Drafts a customer-facing reply from the ticket thread. The payload is scalar and
// no persisted ticket state changes, so there are no fragment spreads here — there
// is nothing for Relay to refresh. The caller puts draftText into the editor.
const mutation = graphql`
	mutation generateTicketReplyDraftMutation($input: GenerateTicketReplyDraftInput!) {
		generateTicketReplyDraft(input: $input) {
			clientMutationId
			draftText
			modelVersion
		}
	}
`;

function commit(
	environment: Environment,
	input: GenerateTicketReplyDraftInput,
	onCompleted?: (r: generateTicketReplyDraftMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	return commitMutation<generateTicketReplyDraftMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), ...input},
		},
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'generateTicketReplyDraftMutation'};
